import {useRef, useCallback} from 'react'

interface Props {
  lockScroll: () => void
  unlockScroll: () => void
}

export const useScrollLock = (): Props => {
  const scrollBlocked = useRef<boolean>(false)

  const lockScroll = useCallback((): void => {
    if (scrollBlocked.current) return

    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth
    const bodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right')) || 0

    document.body.style.overflow = 'hidden'
    document.body.style.paddingRight = `${bodyPaddingRight + scrollBarWidth}px`

    scrollBlocked.current = true
  }, [])

  const unlockScroll = useCallback((): void => {
    if (!scrollBlocked.current) return

    document.body.style.overflow = ''
    document.body.style.paddingRight = ''

    scrollBlocked.current = false
  }, [])

  return {lockScroll, unlockScroll}
}
